import {
  index,
  integer,
  pgTable,
  serial,
  text,
  uuid,
} from "drizzle-orm/pg-core";

import { users } from "./auth";
import { matchSets } from "./match-sets";
import { scoreTeamEnum, timestamps } from "./shared";

export const scoreEvents = pgTable(
  "score_events",
  {
    id: serial().primaryKey(),
    matchSetId: integer()
      .notNull()
      .references(() => matchSets.id, { onDelete: "cascade" }),
    clientEventId: uuid().notNull().unique(),
    team: scoreTeamEnum().notNull(),
    delta: integer().notNull(),
    teamAScoreAfter: integer(),
    teamBScoreAfter: integer(),
    versionAfter: integer(),
    createdBy: text().references(() => users.id),
    ...timestamps,
  },
  (table) => [
    index("score_events_match_set_id_idx").on(table.matchSetId, table.id),
    index("score_events_created_by_idx").on(table.createdBy),
  ],
);
